import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import "./TaskPage.css";
import BASE_URL from "../../../config/api";
import { useParams } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import PersonIcon from "@mui/icons-material/Person";
import AdminLayout from "../../../components/AdminDashboard/AdminLayout/AdminLayout";
import { AppContext } from "../../../context/AppContext";

export default function TaskPage() {
  const [taskData, setTaskData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id, sectionId, lessonId } = useParams();
  const { token } = useContext(AppContext);
  function formatTimestamp(timestampString) {
    const dateObject = new Date(timestampString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    const formattedDateTime = dateObject.toLocaleString("en-US", options);
    return formattedDateTime;
  }

  useEffect(() => {
    const fetchTasksAndAttendance = async () => {
      try {
        const tasksResponse = await axios.get(
          `${BASE_URL}/courses/${id}/sections/${sectionId}/lessons/${lessonId}/tasks`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setTaskData(tasksResponse.data.tasks);
      } catch (error) {
        // console.log(error.response.data);
      }

      try {
        const attendanceResponse = await axios.get(
          `${BASE_URL}/courses/${id}/sections/${sectionId}/lessons/${lessonId}/attendance/bulk`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setAttendanceData(attendanceResponse.data);
      } finally {
        setLoading(false);
      }
    };

    if (token) fetchTasksAndAttendance();
  }, [id, sectionId, lessonId, token]);

  return (
    <AdminLayout>
      <div className="tasks-page-wrapper">
        <h2>Tasks and Attendance for Lesson</h2>
        {loading && <CircularProgress />}
        {!loading && (
          <>
            <p className="task-icons">
              <BorderColorIcon className="task-icon" fontSize="medium" />
              {"  "}
              {taskData && taskData.length} people did their tasks.
            </p>
            <p className="task-icons">
              <TaskAltIcon className="task-icon" fontSize="medium" />
              {"  "}
              {attendanceData && attendanceData.length} people completed this
              lesson.
            </p>
            {taskData.length > 0 ? (
              <TableContainer
                component={Paper}
                style={{ marginBottom: "20px" }}
              >
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <PersonIcon /> User
                      </TableCell>
                      <TableCell>Task Link</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {taskData.map((task) => (
                      <TableRow key={task.taskLink}>
                        <TableCell>{task.studentName}</TableCell>
                        <TableCell>
                          <a
                            href={task.taskLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {task.taskLink}
                          </a>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <p>No tasks available for this lesson.</p>
            )}

            <h2>Attendance for Lesson</h2>
            {attendanceData && attendanceData.length > 0 ? (
              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <PersonIcon /> User
                      </TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Attendance Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {attendanceData.map((attendance) => (
                      <TableRow key={attendance._id}>
                        <TableCell>{attendance.studentName}</TableCell>
                        <TableCell>
                          {formatTimestamp(attendance.date)}
                        </TableCell>
                        <TableCell>
                          Completed{" "}
                          <TaskAltIcon fontSize="small" className="task-icon" />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <p>No attendance data available for this lesson.</p>
            )}
          </>
        )}
      </div>
    </AdminLayout>
  );
}
